
import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const NodeZeroMappingForm = forwardRef(function NodeZeroMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { pentestId, pentestName, nodeZeroIp } = props.record;
      return [{id: pentestId, name: pentestName, otherProperties: { nodeZeroIp}}]
    }
    return [];
  });
  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching projects')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { pentestId } = config;
    const {name:pentestName, otherProperties:{nodeZeroIp}}  = projects.find(project => project.id === pentestId)

    return { pentestId, pentestName, nodeZeroIp };
  }

  const extraFields = useMemo(() => ([{
      name: 'pentestId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Pentest Name',
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default NodeZeroMappingForm;
